import { render, staticRenderFns } from "./thing.vue?vue&type=template&id=20ffed09&scoped=true&"
import script from "./thing.vue?vue&type=script&lang=js&"
export * from "./thing.vue?vue&type=script&lang=js&"
import style0 from "./thing.vue?vue&type=style&index=0&id=20ffed09&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ffed09",
  null
  
)

export default component.exports